import { SyntheticEvent } from 'react';

import { useOperationClients } from 'api/requests/operation';
import { PrimaryClientType } from 'api/types/entity';
import { useSearchDebounce } from 'hooks/useSearchDebounce';
import { useTranslation } from 'libs/i18n';
import { Field, useField } from 'modules/operation/common/forms/operationForm';

interface ClientAutocompleteFeatureProps {
  clientType: PrimaryClientType;
  disabled?: boolean;
}

export const ClientAutocompleteFeature = ({
  clientType,
  disabled,
}: ClientAutocompleteFeatureProps) => {
  const { t } = useTranslation();

  const { search, debouncedFunc } = useSearchDebounce();

  const { helpers: orderHelpers } = useField('order');

  const { listData, loading } = useOperationClients({
    pagination: { limit: 20, page: 0 },
    filter: {
      search,
    },
    params: { clientType },
  });

  const onChange = () => {
    orderHelpers.setValue(undefined);
    debouncedFunc('');
  };

  const onInputChange = (_: SyntheticEvent, v: string) => {
    debouncedFunc(v);
  };

  return (
    <Field.Autocomplete
      key={clientType ?? 'client-field'}
      disabledFilterOptions
      fullWidth
      showRequiredMark
      disabled={disabled}
      label={t('operation.sections.clientsOrderSection.fields.client.label')}
      loading={loading}
      name="client"
      optionLabelKey="label"
      options={(listData?.list ?? []).map((record) => ({
        label: `${record.name} (${record.personalAccountNumber})`,
        value: record.id,
        record,
      }))}
      optionValueKey="value"
      placeholder={t(
        'operation.sections.clientsOrderSection.fields.client.placeholder'
      )}
      onChange={onChange}
      onInputChange={onInputChange}
    />
  );
};
